import { BaseService, RequestType } from "@intech/react-service";
import { FichaFechamentoEntidade } from "../entidades/FichaFechamentoEntidade";

class FichaFechamento extends BaseService {

  constructor() {
    super("fichaFechamento");
  }

  BuscarSaldoPorPlano = (cdPlano: string) =>
    this.CreateRequest<FichaFechamentoEntidade>(RequestType.GET, `porPlano/${cdPlano}`);

  BuscarDatasExtrato = (cdPlano: string) =>
    this.CreateRequest<any>(RequestType.GET, `datasExtrato/${cdPlano}`);
}

export const FichaFechamentoService = new FichaFechamento();